import {
  Button,
  Field,
  FieldProps,
  Input,
  InputOnChangeData,
  InputProps,
  mergeClasses,
} from "@fluentui/react-components";
import VisibilityOutlineIcon from "~icons/material-symbols/visibility-outline";
import VisibilityOffOutlineIcon from "~icons/material-symbols/visibility-off-outline";
import { omit } from "lodash";
import { ChangeEvent, useState } from "react";
import { useController, UseControllerProps } from "react-hook-form";
import { useFormFieldStyles } from "./styles";

type FormFieldProps = UseControllerProps<any> &
  Omit<FieldProps, "name"> &
  Omit<InputProps, "name" | "label" | "onChange"> & {
    helperText?: string;
    label?: string;
    onChange?: (
      ev: ChangeEvent<HTMLInputElement>,
      data: InputOnChangeData,
      formField: (...event: any[]) => void
    ) => void;
  };

export const FormField = ({ label, type, helperText, onChange, ...props }: FormFieldProps) => {
  const styles = useFormFieldStyles();
  const [showPassword, setShowPassword] = useState(false);

  const {
    field: { onChange: fieldOnchange, ...field },
    fieldState: { error },
  } = useController(omit(props, ["disabled"]));

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const onChangeFn = (ev: ChangeEvent<HTMLInputElement>, data: InputOnChangeData) => {
    if (onChange) {
      onChange(ev, data, fieldOnchange);
    }
    fieldOnchange(data.value);
  };

  return (
    <Field
      className={styles.inputFieldWrapper}
      label={<span className={mergeClasses(styles.inputFieldLabel, styles.textUpperCase)}>{label}</span>}
      validationMessage={helperText ?? error?.message}
    >
      <Input
        className={styles.inputField}
        type={type === "password" && showPassword ? "text" : type}
        onChange={onChangeFn}
        contentAfter={
          type === "password" ? (
            <Button
              onClick={toggleShowPassword}
              size="small"
              appearance="transparent"
              icon={
                showPassword ? (
                  <VisibilityOffOutlineIcon className="text-[20px]" />
                ) : (
                  <VisibilityOutlineIcon className="text-[20px]" />
                )
              }
            />
          ) : undefined
        }
        {...props}
        {...field}
      />
    </Field>
  );
};
